import React, { useEffect } from "react";
import { useDispatch } from "./store";
import { logHomeViewed } from "./util/analytics";
import { fetchHome } from "./store/actions/home";
import ErrorBoundary from "./components/ErrorBoundary";

function App({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    fetchHome(dispatch);
    logHomeViewed();
  }, [dispatch]);

  return <ErrorBoundary team="cd.bauhaus">{children}</ErrorBoundary>;
}

export default App;
